module.exports = __webpack_public_path__ + "static/media/swap-component.668bec8c.png";